export const LOAN_PURPOSE_OPTIONS = [
    {
        id: '1',
        translationKey: 'financing.loan_purpose.for_studies',
    },
    {
        id: '2',
        translationKey: 'financing.loan_purpose.vehicle_financing',
    },
    {
        id: '3',
        translationKey: 'financing.loan_purpose.home_improvements',
    },
    {
        id: '4',
        translationKey: 'financing.loan_purpose.medical_expenses',
    },
    {
        id: '5',
        translationKey: 'financing.loan_purpose.for_consumption',
    },
    {
        id: '6',
        translationKey: 'financing.loan_purpose.for_vacation',
    },
    {
        id: '7',
        translationKey: 'financing.loan_purpose.debt_consolidation',
    },
];
